<template>
    <v-dialog v-model="viewColumnsFilter" width="1000px">
        <v-card>
            <v-card-title class="text-h5 grey lighten-2"> Colonnes </v-card-title>
            <div class="filters-body">
                <search-panorama-subjects
                    v-model="subjectsRequired"
                    :displayedSubjects="displayedSubjects"
                    :subjects="subjects"
                />
            </div>
            <v-card-actions>
                <v-spacer></v-spacer>
                <action class="apply-button" @click="emitQuery" name="main" :nochevron="true">
                    Appliquer
                </action>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from "src/bus/eventBus";
import SearchPanoramaSubjects from "./SearchPanoramaSubjects.vue";

export default {
    props: ["subjects", "displayedSubjects"],
    components: { SearchPanoramaSubjects },
    data() {
        return {
            viewColumnsFilter: false,
            subjectsRequired: [],
        };
    },
    mounted() {
        EventBus.$on("openPanoramaColumnsFilter", viewColumnsFilter => {
            this.viewColumnsFilter = viewColumnsFilter;
        });
    },
    methods: {
        emitQuery() {
            EventBus.$emit(
                "subjectsChanged",
                this.subjects.filter(subject => this.subjectsRequired.indexOf(subject.code) > -1)
            );
            EventBus.$emit("openPanoramaColumnsFilter", false);
        },
    },
};
</script>

<style scoped lang="sass">
.filters-body
    margin-left: 16px
    margin-right: 16px
.apply-button
    margin: 0 16px
</style>
